import _slicedToArray from "C:\\Users\\dell\\Downloads\\Projects\\fezile-fashion-skills-academy\\site\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Wizard/wizard';
import AngleRightIcon from '@patternfly/react-icons/dist/esm/icons/angle-right-icon';
import { useOUIAProps } from '../../helpers';
export var WizardNavItem = function WizardNavItem(_a) {
  var _a$children = _a.children,
    children = _a$children === void 0 ? null : _a$children,
    _a$content = _a.content,
    content = _a$content === void 0 ? '' : _a$content,
    _a$isCurrent = _a.isCurrent,
    isCurrent = _a$isCurrent === void 0 ? false : _a$isCurrent,
    _a$isDisabled = _a.isDisabled,
    isDisabled = _a$isDisabled === void 0 ? false : _a$isDisabled,
    step = _a.step,
    _a$onNavItemClick = _a.onNavItemClick,
    onNavItemClick = _a$onNavItemClick === void 0 ? function () {
      return undefined;
    } : _a$onNavItemClick,
    _a$navItemComponent = _a.navItemComponent,
    navItemComponent = _a$navItemComponent === void 0 ? 'button' : _a$navItemComponent,
    _a$href = _a.href,
    href = _a$href === void 0 ? null : _a$href,
    _a$isExpandable = _a.isExpandable,
    isExpandable = _a$isExpandable === void 0 ? false : _a$isExpandable,
    id = _a.id,
    ouiaId = _a.ouiaId,
    _a$ouiaSafe = _a.ouiaSafe,
    ouiaSafe = _a$ouiaSafe === void 0 ? true : _a$ouiaSafe,
    rest = __rest(_a, ["children", "content", "isCurrent", "isDisabled", "step", "onNavItemClick", "navItemComponent", "href", "isExpandable", "id", "ouiaId", "ouiaSafe"]);
  var ouiaProps = useOUIAProps(WizardNavItem.displayName, ouiaId, ouiaSafe);
  var NavItemComponent = navItemComponent;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isExpanded = _React$useState2[0],
    setIsExpanded = _React$useState2[1];
  React.useEffect(function () {
    setIsExpanded(isCurrent);
  }, [isCurrent]);
  if (navItemComponent === 'a' && !href && process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error('WizardNavItem: When using an anchor, please provide an href');
  }
  var btnProps = {
    disabled: isDisabled
  };
  var linkProps = {
    tabIndex: isDisabled ? -1 : undefined,
    href: href
  };
  return React.createElement("li", {
    className: css(styles.wizardNavItem, isExpandable && styles.modifiers.expandable, isExpandable && isExpanded && styles.modifiers.expanded)
  }, React.createElement(NavItemComponent, Object.assign({}, rest, navItemComponent === 'a' ? Object.assign({}, linkProps) : Object.assign({}, btnProps), id && {
    id: id.toString()
  }, {
    onClick: function onClick() {
      return isExpandable ? setIsExpanded(!isExpanded || isCurrent) : onNavItemClick(step);
    },
    className: css(styles.wizardNavLink, isCurrent && styles.modifiers.current, isDisabled && styles.modifiers.disabled),
    "aria-disabled": isDisabled ? true : null,
    "aria-current": isCurrent && !children ? 'step' : false
  }, isExpandable && {
    'aria-expanded': isExpanded
  }, ouiaProps), isExpandable ? React.createElement(React.Fragment, null, React.createElement("span", {
    className: css(styles.wizardNavLinkText)
  }, content), React.createElement("span", {
    className: css(styles.wizardNavLinkToggle)
  }, React.createElement("span", {
    className: css(styles.wizardNavLinkToggleIcon)
  }, React.createElement(AngleRightIcon, null)))) : content), children);
};
WizardNavItem.displayName = 'WizardNavItem';